import { CITIES, STATES } from "../constants/constants";

const options = [...STATES, ...CITIES]
  .sort((a, b) => a.localeCompare(b))
  .map((item) => ({ value: item, label: item, type: STATES.includes(item) ? 'state' : 'city' }));

// const communityOptions = [
//   {
//     value: 'General',
//     label: 'General'
//   },
//   ...[...STATES, ...CITIES]
//   .sort((a, b) => a.localeCompare(b))
//   .map((item) => ({ value: item, label: item, type: STATES.includes(item) ? 'state' : 'city' }))
// ];

const stateOptions = [
  {
    value: 'General',
    label: 'General'
  },
  ...STATES
    .sort((a, b) => a.localeCompare(b))
    .map((state) => ({ value: state, label: state, type: 'state' }))
];
const cityOptions = [
  {
    value: 'General',
    label: 'General'
  },
  ...CITIES
    .sort((a, b) => a.localeCompare(b))
    .map((city) => ({ value: city, label: city, type: 'city' }))
];




const sleep = (ms) =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve(undefined);
    }, ms);
  });

export const loadOptions = async (search, prevOptions) => {
  await sleep(1000);

  let filteredOptions;
  if (!search) {
    filteredOptions = options;
  } else {
    const searchLower = search.toLowerCase();

    filteredOptions = options.filter(({ label }) =>
      label.toLowerCase().startsWith(searchLower)
    );
  }

  const hasMore = filteredOptions.length > prevOptions.length + 10;
  const slicedOptions = filteredOptions.slice(
    prevOptions.length,
    prevOptions.length + 10
  );

  return {
    options: slicedOptions,
    hasMore,
  };
};

export const addNewOption = async (inputValue) => {
  await sleep(1000);

  const newOption = {
    label: inputValue,
    value: inputValue,
  };

  options.push(newOption);

  return newOption;
};

// export const communityLoadOptions = async (search, prevOptions) => {
//   await sleep(1000);

//   let filteredOptions;
//   if (!search) {
//     filteredOptions = communityOptions;
//   } else {
//     const searchLower = search.toLowerCase();

//     filteredOptions = communityOptions.filter(({ label }) =>
//       label.toLowerCase().includes(searchLower)
//     );
//   }

//   const hasMore = filteredOptions.length > prevOptions.length + 10;
//   const slicedOptions = filteredOptions.slice(
//     prevOptions.length,
//     prevOptions.length + 10
//   );

//   return {
//     options: slicedOptions,
//     hasMore,
//   };
// };


export const communityStateLoadOptions = async (search, prevOptions) => {
  await sleep(1000);

  let filteredOptions;
  if (!search) {
    filteredOptions = stateOptions;
  } else {
    const searchLower = search.toLowerCase();

    filteredOptions = stateOptions.filter(({ label }) =>
      label.toLowerCase().includes(searchLower)
    );
  }

  const hasMore = filteredOptions.length > prevOptions.length + 10;
  const slicedOptions = filteredOptions.slice(
    prevOptions.length,
    prevOptions.length + 10
  );

  return {
    options: slicedOptions,
    hasMore,
  };
};

export const communityCityLoadOptions = async (search, prevOptions) => {
  await sleep(1000);

  let filteredOptions;
  if (!search) {
    filteredOptions = cityOptions;
  } else {
    const searchLower = search.toLowerCase();

    filteredOptions = cityOptions.filter(({ label }) =>
      label.toLowerCase().includes(searchLower)
    );
  }

  const hasMore = filteredOptions.length > prevOptions.length + 10;
  const slicedOptions = filteredOptions.slice(
    prevOptions.length,
    prevOptions.length + 10
  );

  return {
    options: slicedOptions,
    hasMore,
  };
};